// ─── Modern Minimal V1 ────────────────────────────────────────
// Contemporary editorial wedding invitation. Forest-cream palette,
// DM Serif Display headings, left-aligned section headings with
// eyebrow labels. Split hero, stacked details, tight gallery grid.

export const modernMinimalV1 = {
  templateId: 'modern-minimal-v1',
  name: 'Modern Minimal',
  description: 'Contemporary editorial style. Clean lines, forest-cream tones.',
  category: 'wedding',
  previewColors: ['#F5F3EC', '#556B5D', '#1C241F'],
  theme: {
    palette: 'forest-cream',
    fontPair: 'dmserif-plusjakarta',
    radius: 'soft',
    shadow: 'soft',
    overlay: 'none',
  },
  settings: {
    musicEnabled: false,
    countdownEnabled: false,
    rsvpEnabled: true,
    showMapLink: true,
  },
  sections: [
    {
      id: 'hero-1',
      type: 'hero',
      variant: 'hero-split',
      visible: true,
      animation: {
        title: 'stagger-text',
        subtitle: 'fade-up',
        image: 'zoom-soft',
      },
      editableRules: {
        fields: ['introLabel', 'title', 'subtitle', 'dateText', 'backgroundImage', 'ctaText'],
        locked: ['layout', 'spacing', 'typographyScale'],
      },
      data: {
        introLabel: 'Wedding Invitation',
        title: 'Emma & Noah',
        subtitle: 'A contemporary celebration in the heart of the city.',
        dateText: '18 July 2026 · 17:30',
        backgroundImage: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?q=80&w=1600&auto=format&fit=crop',
        ctaText: 'View details',
      },
    },
    {
      id: 'details-1',
      type: 'event-details',
      variant: 'details-stack',
      visible: true,
      animation: { items: 'stagger-cards' },
      editableRules: {
        fields: ['date', 'time', 'venue', 'address'],
        locked: ['grid', 'iconStyle', 'spacing'],
      },
      data: {
        date: 'Saturday, 18 July 2026',
        time: '17:30',
        venue: 'Atelier House',
        address: 'Lisbon, Portugal',
      },
    },
    {
      id: 'timeline-1',
      type: 'timeline',
      variant: 'timeline-vertical',
      visible: true,
      animation: { items: 'stagger-cards' },
      editableRules: {
        fields: ['items'],
        locked: ['connectorStyle', 'spacing', 'layout'],
      },
      data: {
        items: [
          { time: '17:30', title: 'Ceremony', description: 'An intimate city ceremony.' },
          { time: '19:00', title: 'Dinner', description: 'Cocktails and seated dinner.' },
          { time: '21:30', title: 'Celebration', description: 'Music, dancing, and late-night moments.' },
        ],
      },
    },
    {
      id: 'gallery-1',
      type: 'gallery',
      variant: 'gallery-grid',
      visible: true,
      animation: { items: 'zoom-soft' },
      editableRules: {
        fields: ['images'],
        locked: ['grid', 'gap', 'imageRatio'],
      },
      data: {
        images: [
          'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?q=80&w=900&auto=format&fit=crop',
          'https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=900&auto=format&fit=crop',
          'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?q=80&w=900&auto=format&fit=crop',
          'https://images.unsplash.com/photo-1520854221256-17451cc331bf?q=80&w=900&auto=format&fit=crop',
        ],
      },
    },
    {
      id: 'venue-1',
      type: 'venue',
      variant: 'venue-split',
      visible: true,
      animation: { section: 'fade-up' },
      editableRules: {
        fields: ['venueName', 'address', 'mapLink', 'note', 'image'],
        locked: ['layout', 'spacing', 'buttonStyle'],
      },
      data: {
        venueName: 'Atelier House',
        address: 'Lisbon, Portugal',
        mapLink: 'https://maps.google.com',
        note: 'A modern venue with indoor and outdoor spaces.',
        image: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=1200&auto=format&fit=crop',
      },
    },
    {
      id: 'rsvp-1',
      type: 'rsvp',
      variant: 'rsvp-minimal',
      visible: true,
      animation: { section: 'fade-up' },
      editableRules: {
        fields: ['title', 'description', 'submitLabel'],
        locked: ['validationRules', 'inputStyle', 'spacing'],
      },
      data: {
        title: 'RSVP',
        description: 'Please confirm your attendance by 20 June 2026.',
        submitLabel: 'Send response',
      },
    },
    {
      id: 'footer-1',
      type: 'footer',
      variant: 'footer-minimal',
      visible: true,
      animation: { section: 'fade-in' },
      editableRules: {
        fields: ['closingMessage', 'names'],
        locked: ['layout', 'spacing'],
      },
      data: {
        closingMessage: 'We look forward to celebrating with you.',
        names: 'Emma & Noah',
      },
    },
  ],
};
